
// packages
import { Box, Typography, Stack, Button } from '@mui/material'
import { useMediaQuery } from '@mui/material';


const PlainModal = ({headerString, actionString = null, action, handleClose}) => {
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // DEFINITIONS
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const isMobile = useMediaQuery("(max-width:600px)");

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // STYLES 
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '65vw',
        bgcolor: 'background.paper',
        borderRadius: 4,
        boxShadow: 24,
        p: 4,
    }
    const mobileModalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: '65vw',
        bgcolor: 'background.paper',
        borderRadius: 4,
        boxShadow: 24,
        p: 4,
    }

    return (
        <Box sx={!isMobile ? (modalStyle) : (mobileModalStyle)}>
            <Typography id="modal-modal-title" variant="h6" component="h2" sx={{fontWeight:600}}>
            {headerString}
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2, mb:2 }}>
            {actionString ?? ''}
            </Typography>
            <Stack direction={'row'} sx={{p:0, justifyContent:'space-between'}}>
                <Button variant='outlined' sx={{}} onClick={() => handleClose()}>Cancel</Button>
                <Button variant='contained' onClick={() => {
                    action();
                }}>
                    Confirm
                </Button>
            </Stack>
        </Box>
    );
}

export default PlainModal;